import { FiUpload } from 'react-icons/fi'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'

const SaveStepButton = (props) => {
    return (
        <Button
            size="lg"
            variant="primary"
            className="float-end"
            disabled={props.isSubmitting}
            onClick={props.onClick}
        >
            {props.isSubmitting
                ? <Spinner animation="border" size="sm" variant="secondary" className="mx-5" />
                : <><FiUpload />{props.isLastStep ? ' Save and finish' : ' Save and continue'}</>
            }
        </Button>
    )
}

export default SaveStepButton